var $2b9e50ee093c0349$exports = {};
$2b9e50ee093c0349$exports = {
  "collapse": "\u6298\u308A\u305F\u305F\u3080",
  "expand": "\u5C55\u958B"
};
export { $2b9e50ee093c0349$exports as default };